import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import StepFour from "./Forgot/StepFour";
import StepOne from "./Forgot/StepOne";
import StepTwo from "./Forgot/StepTwo";
import StepThree from "./Forgot/StepThree";
export default function ForgotPassword() {
    var _a = useState(1), step = _a[0], setStep = _a[1]; // 1 - email, 2 - code, 3 - password, 4 - success
    var _b = useState(''), uuid = _b[0], setUuid = _b[1];
    var _c = useState(''), code = _c[0], setCode = _c[1];
    var onFinishStepOne = function (uuid) {
        setUuid(uuid);
        setStep(2);
    };
    var onFinishStepTwo = function (userCode) {
        setCode(userCode);
        setStep(3);
    };
    switch (step) {
        case 4:
            return _jsx(StepFour, {});
        case 3:
            return _jsx(StepThree, { resetCode: code, uuid: uuid, onComplete: function () { return setStep(4); } });
        case 2:
            return _jsx(StepTwo, { uuid: uuid, onComplete: onFinishStepTwo });
        default:
            return _jsx(StepOne, { onComplete: onFinishStepOne });
    }
}
